export default __webpack_public_path__ + "static/media/090.a8d8f79a.gif";